import { useMutation, useQueryClient } from '@tanstack/react-query';
import { captureSentryException } from '@/lib/sentry';
import { supabase } from '@/integrations/supabase/client';
import posthog from '@/lib/posthog';
import { toast } from 'sonner';

interface ToggleGivingAwayArgs {
  itemId: string;
  isGivingAway: boolean;
}

export function useToggleGivingAway() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ itemId, isGivingAway }: ToggleGivingAwayArgs) => {
      const { error } = await supabase
        .from('items')
        .update({ is_giving_away: isGivingAway })
        .eq('id', itemId);

      if (error) throw error;
    },
    onSuccess: (_data, { itemId, isGivingAway }) => {
      queryClient.invalidateQueries({ queryKey: ['items'] });
      queryClient.invalidateQueries({ queryKey: ['my-items'] });
      queryClient.invalidateQueries({ queryKey: ['group-activity'] });
      posthog.capture('item_giving_away_toggled', {
        item_id: itemId,
        is_giving_away: isGivingAway,
      });
    },
    onError: (error) => {
      captureSentryException(error);
      toast.error('Could not update item. Please try again.');
    },
  });
}
